var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogoCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1080,
    viewBox: "0 0 1080 1080",
    width: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M729.796 386.21L662.016 705.86C656.902 728.42 643.567 734.032 624.616 723.408L521.342 647.304L471.512 695.231C465.998 700.745 461.384 705.359 450.756 705.359L458.176 600.178L649.583 427.219C657.907 419.799 647.779 415.688 636.649 423.108L400.021 572.103L298.151 540.22C275.992 533.3 275.593 518.06 302.763 507.433L701.219 353.924C719.667 347.007 735.81 358.035 729.796 386.21Z",
    fill: "#2AABEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 760,
    rx: 380,
    stroke: "#2AABEE",
    strokeWidth: 27,
    width: 760,
    x: 157.5,
    y: 159.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear",
    x1: 468.5,
    x2: 710.864,
    y1: 286.5,
    y2: 883.047
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBFEC",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear",
    x1: 346,
    x2: 700.902,
    y1: 191,
    y2: 900.799
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77C4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20A0E1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogoCircleIcon);
export default __webpack_public_path__ + "static/media/telegram_logo_circle_icon.03ae720d331c41fb65492674792d4fd1.svg";
export { ForwardRef as ReactComponent };